module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Line-d70f478242c04c7edea1fbd2ec9f209e.svg";